export enum VisibilityEnum {
  ME = 'me',
  MY_TEAM = 'my_team',
  EVERYONE = 'everyone'
}

/** Encounter care plan scope returned by GET /api/encounters/:id/care-plan */
export enum EncounterCarePlanType {
  NOTE = 'note',
  PROCEDURE = 'procedure',
}

export enum SequenceEnum {
  BEFORE = 'before',
  AFTER = 'after'
}

export interface CreateEncounterCarePlanDto {
  encounterId: string;
  organizationId?: string;
  version?: string;
  visibility?: VisibilityEnum;
  createdBy?: string;
  templateId?: string;
  type?: EncounterCarePlanType | string;
}

export interface UpdateEncounterCarePlanDto {
  version?: string;
  visibility?: VisibilityEnum;
  templateId?: string;
}

export interface AddContextToCarePlanDto {
  templateId: string;
  associatedEntityId?: string;
  associatedEntityType?: string;
  order?: number;
  isRequired?: boolean;
  sequence?: SequenceEnum;
  sequenceTemplateId?: string;
  category?: string;
  isDefault?: boolean;
  lastIndicated?: boolean;
  /**
   * Which encounter care plan receives this detail when created via context
   * `carePlanDetail` / care-plan context APIs (`note` | `procedure`).
   */
  carePlanType?: EncounterCarePlanType | string;
}

export interface BulkAddContextsToCarePlanDto {
  contexts: AddContextToCarePlanDto[];
}

export interface UpdateCarePlanDetailDto {
  templateId?: string;
  associatedEntityId?: string;
  associatedEntityType?: string;
  order?: number;
  isRequired?: boolean;
  sequence?: SequenceEnum;
  sequenceTemplateId?: string;
  category?: string;
  isDefault?: boolean;
  lastIndicated?: boolean;
}

export interface ReorderItemDto {
  id: string;
  order: number;
}

export interface ReorderCarePlanDetailsDto {
  items: ReorderItemDto[];
}

export interface CarePlanDetailResponseDto {
  id: string;
  encounterCarePlanId?: string;
  templateCarePlanId?: string;
  associatedEntityId?: string;
  associatedEntityType?: string;
  templateId?: string;
  order: number;
  isRequired: boolean;
  isDefault?: boolean;
  lastIndicated?: boolean;
  sequence: SequenceEnum | string;
  sequenceContextId?: string | null;
  sequenceTemplateId?: string | null;
  category: string | null;
  createdAt: Date;
  updatedAt: Date;
  context?: {
    id: string;
    title: string | null;
    summary: string | null;
    type: string | null;
  };
  template?: {
    id: string;
    title: string | null;
    content?: string | null;
    templateType?: string | null;
  };
}

export interface EncounterCarePlanResponseDto {
  id: string;
  encounterId?: string;
  templateId?: string;
  type?: EncounterCarePlanType | string;
  organizationId: string;
  version: string | null;
  visibility: VisibilityEnum | string;
  createdBy: string | null;
  createdAt: Date;
  updatedAt: Date;
  details?: CarePlanDetailResponseDto[];
}

